import SegmentViewer from "./SegmentViewer";

export default SegmentViewer;
